<template>
  <van-popup
    v-model:show="innerShow"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <van-form @submit="onSubmit" scroll-to-error class="process">
      <van-nav-bar
        title="维修过程"
        left-text="返回"
        left-arrow
        @click-left="innerShow = false"
      />
      <div class="inner">
        <van-cell-group title="故障类型：">
          <!-- 故障类型 -->
          <template
            v-for="(faultType, index) in state.faultType"
            :key="faultType.id"
          >
            <van-field
              :name="'faultType' + index"
              v-model="faultType.fieldValue"
              readonly
              clickable
              required
              label="故障类型"
              placeholder="请选择故障类型"
              :rules="[{ required: true, message: '请选择故障类型' }]"
              @click="faultType.show = true"
            >
            </van-field>
            <div @click.stop class="fault-type">
              <van-stepper
                style="margin-right: 30px"
                v-model="faultType.sum"
                input-width="20"
                button-size="25"
                integer
              />
              <van-button
                round
                size="mini"
                icon="plus"
                type="primary"
                style="margin-right: 10px"
                @click="addFaultType"
              />
              <van-button
                round
                :disabled="state.faultType.length === 1"
                size="mini"
                icon="minus"
                type="primary"
                @click="removeFaultType(index)"
              />
            </div>

            <van-popup v-model:show="faultType.show" round position="bottom">
              <van-picker
                :columns="state.faultTypeColumns"
                :columns-field-names="{
                  text: 'faulttype_name',
                  children: 'sub_list',
                }"
                @cancel="faultType.show = false"
                @confirm="faultTypeConfirm($event, faultType)"
              />
            </van-popup>
          </template>
        </van-cell-group>

        <van-cell-group style="margin-top: 10px">
          <!-- 接单时间 -->
          <van-field
            v-model="state.acceptTime.fieldValue"
            readonly
            clickable
            label="接单时间"
            placeholder="选择接单时间"
            @click="state.acceptTime.show = true"
          />
          <van-popup v-model:show="state.acceptTime.show" position="bottom">
            <van-datetime-picker
              v-model="state.acceptTime.value"
              type="datetime"
              title="选择接单时间"
              :min-date="state.acceptTime.minDate"
              :max-date="state.repairEndTime.date"
              @confirm="dateConfirm($event, 'acceptTime')"
              @cancel="state.acceptTime.show = false"
            />
          </van-popup>
          <!-- 接单时间 end -->
          <!-- 完成时间 -->
          <van-field
            v-model="state.repairEndTime.fieldValue"
            readonly
            clickable
            label="完成时间"
            placeholder="选择完成时间"
            @click="state.repairEndTime.show = true"
          />
          <van-popup v-model:show="state.repairEndTime.show" position="bottom">
            <van-datetime-picker
              v-model="state.repairEndTime.value"
              type="datetime"
              title="选择完成时间"
              :min-date="state.acceptTime.date"
              :max-date="state.repairEndTime.maxDate"
              @confirm="dateConfirm($event, 'repairEndTime')"
              @cancel="state.repairEndTime.show = false"
            />
          </van-popup>
          <!-- 完成时间 end -->
          <!-- 维修状态 -->
          <van-field label="维修状态">
            <template #input>
              <van-radio-group v-model="state.repairState">
                <van-radio name="2">已修好</van-radio>
                <van-radio name="1">未修好</van-radio>
                <van-radio name="3" v-if="power('1-7-2')">无法维修</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 维修状态 end -->
          <!-- 特殊工单 -->
          <van-field
            v-if="state.repairState != '2'"
            v-model="state.collection.fieldValue"
            readonly
            clickable
            label="特殊工单"
            placeholder="请选择特殊工单"
            @click="state.collection.show = true"
          />
          <van-popup
            v-model:show="state.collection.show"
            round
            position="bottom"
          >
            <van-picker
              :columns="state.collection.columns"
              :columns-field-names="{
                text: 'collection_name',
              }"
              @cancel="state.collection.show = false"
              @confirm="collectionConfirm"
            />
          </van-popup>
          <!-- 特殊工单 end -->
          <!-- 特殊备注 -->
          <!-- <van-field
            v-if="state.collection.value !== '1'"
            name="collectionNote"
            v-model="state.collectionNote"
            rows="4"
            autosize
            label="特殊备注"
            type="textarea"
            maxlength="200"
            placeholder="请输入特殊备注"
            show-word-limit
            required
            :rules="[{ required: true, message: '请输入特殊备注' }]"
          /> -->
          <!-- 特殊备注 end -->
        </van-cell-group>
        <van-cell-group style="margin-top: 10px">
          <!-- 现场图片 -->
          <van-field name="upload" label="现场图片">
            <template #input>
              <van-uploader
                v-model="state.upload.fileList"
                :max-count="6"
                :after-read="upload"
              />
            </template>
          </van-field>
          <!-- 现场图片 end -->
          <van-field
            label="已选维修员"
            v-if="power('1-7-1')"
            v-model="state.repair_name"
            readonly
          >
            <template #extra>
              <van-button
                round
                size="mini"
                color="#f8b300"
                @click="userSelector.show = true"
                >修改维修员</van-button
              >
            </template>
          </van-field>
          <!-- 备注 -->
          <van-field
            v-if="state.repairState != '3'"
            name="repairEndNote"
            v-model="state.repairEndNote"
            rows="4"
            autosize
            label="备注信息"
            type="textarea"
            maxlength="200"
            placeholder="请输入备注信息"
            show-word-limit
          />
          <van-field
            v-if="state.repairState == '3'"
            name="repairNotNote"
            v-model="state.repairNotNote"
            rows="2"
            autosize
            label="说明原因"
            type="textarea"
            maxlength="200"
            placeholder="请输入说明原因"
            show-word-limit
          />
          <!-- 备注 end -->
        </van-cell-group>
        <van-cell-group
          style="padding-top: 1px"
          v-if="detail.repair_cost?.length > 0"
          title="应收费用："
        >
          <!-- 应收费用 -->
          <template v-for="cost in detail.repair_cost" :key="cost.item_id">
            <van-divider
              content-position="left"
              :style="{ color: '#969799', borderColor: '#969799' }"
            >
              {{ cost.item_name }}</van-divider
            >
            <van-field
              label="费用/元"
              v-model="cost.amount"
              required
              :disabled="[21, 22].includes(cost.item_id)"
              :rules="[
                { required: true, message: `请输入${cost.item_name}总费用` },
              ]"
            />
            <!-- <van-field
              label="数量"
              required
              :rules="[
                { required: true, message: `请输入${cost.item_name}数量` },
              ]"
            >
              <template #input>
                <van-stepper integer v-model="cost.number" />
              </template>
            </van-field> -->
            <div v-if="cost.item_note" class="cost-note">
              {{ cost.item_note }}
            </div>
          </template>

          <!-- 应收费用 end -->
        </van-cell-group>
        <div style="height: 50px"></div>
      </div>
      <van-button type="primary" block native-type="submit">确定</van-button>
    </van-form>
  </van-popup>
  <!-- 选择派工人员 -->
  <user
    title="修改维修员"
    :default="state.repair_uids.split(',')"
    v-model:show="userSelector.show"
    @submit="userSelector.onSubmit"
  />
</template>
<script>
import { toRefs, useVModel } from "@vueuse/core";
import { reactive } from "vue";
import moment from "moment";
import { baseService } from "@/service";
import { usePower } from "@/hooks";
export default {
  name: "Process",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
    },
  },
  emits: ["update:show", "submit"],
  setup(props, { emit }) {
    const { detail } = toRefs(props);
    const { power } = usePower();
    const currentDate = moment().toDate();

    const state = reactive({
      faultType: [],
      acceptTime: {
        show: false,
        value: currentDate,
        fieldValue: moment().format("YYYY-MM-DD HH:mm"),
        date: currentDate,
        timestamp: moment().format("X"),
        minDate: currentDate,
      },
      repair_name: "",
      repair_uids: "",
      repairEndTime: {
        show: false,
        value: currentDate,
        date: currentDate,
        fieldValue: moment().format("YYYY-MM-DD HH:mm"),
        timestamp: moment().format("X"),
        maxDate: currentDate,
      },
      repairState: "2",
      collection: {
        show: false,
        value: "",
        fieldValue: "",
        columns: [],
      },
      upload: {
        fileList: [],
      },
      collectionNote: "",
      repairEndNote: "",
      repairNotNote: "",
      faultTypeColumns: [],
    });

    if (detail.value.repair_uids) {
      state.repair_uids = detail.value.repair_uids;
      state.repair_name = detail.value.repair_name;
    }

    if (detail.value.repair_file_jpg_arr) {
      const ids = detail.value.repair_file_ids.split(",");
      state.upload.fileList = detail.value.repair_file_jpg_arr.map(
        (file, index) => {
          return {
            url: file.file_path,
            file_ids: ids[index],
            message: "上传成功",
            status: "done",
          };
        }
      );
    }
    // 派工
    const userSelector = reactive({
      show: false,
      onSubmit(data) {
        const name = data.map((item) => item.name).join();
        const ids = data.map((item) => item.id).join();
        state.repair_name = name;
        state.repair_uids = ids;
      },
    });
    // 类型
    const getFaultTypeList = async () => {
      const { data } = await baseService.faultTypeList();
      state.faultTypeColumns = data;
    };

    getFaultTypeList();

    const faultTypeConfirm = (option, faultType) => {
      faultType.fieldValue = option[1].faulttype_full_name;
      faultType.value = option[1].id;
      faultType.pid = option[1].pid;
      faultType.show = false;
    };

    const addFaultType = () => {
      state.faultType.push({
        id: moment().format("X"),
        show: false,
        value: "",
        pid: "",
        fieldValue: "",
        sum: 1,
      });
    };

    const removeFaultType = (index) => {
      state.faultType.splice(index, 1);
    };

    //  时间确认
    const dateConfirm = (date, type) => {
      state[type].fieldValue = moment(date).format("YYYY-MM-DD HH:mm");
      state[type].timestamp = moment(date).format("X");
      state[type].date = date;
      state[type].show = false;
    };

    // 特殊工单
    const getCollectionList = async () => {
      const { data } = await baseService.collectionList();
      state.collection.columns = data;
      const find = data.find((item) => item.id === "1");
      if (find) {
        state.collection.value = find.id;
        state.collection.fieldValue = find.collection_name;
      }
    };

    getCollectionList();

    const collectionConfirm = (option) => {
      state.collection.fieldValue = option.collection_name;
      state.collection.value = option.id;
      state.collection.show = false;
      state.collectionNote = "";
    };

    // 文件上传
    const upload = async (file) => {
      try {
        file.status = "uploading";
        file.message = "上传中...";
        const data = await baseService.upload(file.file);
        file.status = "done";
        file.message = "上传成功";
        file.file_ids = data.file_ids;
      } catch (error) {
        file.status = "failed";
        file.message = "上传失败";
      }
    };

    // 初始化数据
    const init = () => {
      if (!detail.value) return;
      //   类型的
      if (detail.value.faulttype_info) {
        const nameList = detail.value.faulttype_full_name.split(",");
        const arr = JSON.parse(detail.value.faulttype_info).map(
          (item, index) => {
            return {
              id: index,
              show: false,
              value: item.faulttype_id,
              pid: item.faulttype_type_id,
              fieldValue: nameList[index],
              sum: item.faulttype_sum,
            };
          }
        );
        state.faultType.push(...arr);
      }
      if (state.faultType.length === 0) {
        addFaultType();
      }
      //   接单时间
      if (detail.value.accept_time_name) {
        const defaultDate = moment(detail.value.accept_time_name);
        state.acceptTime.value = defaultDate.toDate();
        state.acceptTime.date = defaultDate.toDate();
        state.acceptTime.fieldValue = defaultDate.format("YYYY-MM-DD HH:mm");
        (state.acceptTime.timestamp = defaultDate.format("X")),
          (state.acceptTime.minDate = moment(
            detail.value.fault_time_name
          ).toDate());
      }
      //   维修状态
      if (detail.value.repair_state) {
        state.repairState = detail.value.repair_state;
      }

      // 应收费用
      if (detail.value.repair_cost?.length > 0) {
        detail.value.repair_cost.forEach((cost) => {
          cost.number = cost.use_amount ? Number(cost.use_amount) : 1;
          cost.amount = cost.use_cost || "0.00";
        });
      }
    };
    init();

    //submit
    const onSubmit = async () => {
      // 应收费用
      let receivables_json = "";
      if (detail.value.repair_cost?.length > 0) {
        receivables_json = JSON.stringify(
          detail.value.repair_cost.map((cost) => {
            return {
              item_id: cost.item_id,
              item_name: cost.item_name,
              item_note: cost.item_note,
              cost: cost.amount,
              amount: cost.number,
            };
          })
        );
      }
      emit("submit", {
        id: detail.value.id,
        faulttype_info: JSON.stringify(
          state.faultType.map((item) => ({
            faulttype_id: item.value,
            faulttype_sum: item.sum,
            faulttype_type_id: item.pid,
          }))
        ),
        repair_state: state.repairState,
        accept_time: state.acceptTime.timestamp,
        repair_uids: state.repair_uids,
        collection_id: state.repairState == "3" ? "" : state.collection.value,
        collection_note: state.repairState == "3" ? "" : state.collectionNote,
        repair_end_time: state.repairEndTime.timestamp,
        repair_end_note:
          state.repairState == "3" ? state.repairNotNote : state.repairEndNote,
        repair_not_note: state.repairState == "3" ? state.repairNotNote : "",
        repair_file_ids: state.upload.fileList
          .map((file) => file.file_ids)
          .join(),
        receivables_json,
      });
      emit("update:show", false);
    };

    return {
      power,
      state,
      faultTypeConfirm,
      addFaultType,
      removeFaultType,
      dateConfirm,
      collectionConfirm,
      upload,
      onSubmit,
      userSelector,
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.process {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .van-radio {
    margin-bottom: 8px;
  }

  .inner {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: #f7f8fa;
  }

  .cost-name {
    padding: 8px 15px;
  }
  .cost-note {
    padding: 10px 15px 5px;
    font-size: 12px;
    color: #969799;
  }
}
.fault-type {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
